/**
 * Priorisierung (Spec §9) — die EINZIGE Stelle mit der Formel.
 *
 * Der Server rechnet den Score beim Speichern einer Bewertung und schreibt ihn nach
 * `Feature.priorityScore` fort; das Web nutzt dieselbe Funktion für die Live-Vorschau
 * im Bewertungsformular. Zwei Implementierungen würden unweigerlich auseinanderlaufen
 * — deshalb liegt sie hier und nirgends sonst.
 */
/** Standardformel aus Spec §9. */
export const DEFAULT_WEIGHTS = {
    customerValue: 3,
    strategicValue: 2,
    technicalValue: 1,
    urgency: 2,
    effort: 2
};
/** Kleinster und groesster Wert, den ein Kriterium annehmen darf. */
export const CRITERION_MIN = 1;
export const CRITERION_MAX = 5;
/** Reihenfolge der Kriterien in Formularen und Auswertungen — einmal festgelegt. */
export const CRITERIA = [
    { key: 'customerValue', label: 'Kundennutzen' },
    { key: 'strategicValue', label: 'Strategische Bedeutung' },
    { key: 'urgency', label: 'Dringlichkeit' },
    { key: 'technicalValue', label: 'Technischer Nutzen' },
    { key: 'effort', label: 'Entwicklungsaufwand' }
];
/**
 * Priorität =
 *   (Kundennutzen × w) + (Strategische Bedeutung × w) + (Dringlichkeit × w)
 *   + (Technischer Nutzen × w) − (Entwicklungsaufwand × w)
 *
 * Das Ergebnis wird gerundet, damit es als `Int` in der Datenbank liegen und stabil
 * sortiert werden kann. Gebrochene Gewichte sind damit ausdruecklich erlaubt.
 */
export function calculatePriority(evaluation, weights = DEFAULT_WEIGHTS) {
    const raw = evaluation.customerValue * weights.customerValue +
        evaluation.strategicValue * weights.strategicValue +
        evaluation.urgency * weights.urgency +
        evaluation.technicalValue * weights.technicalValue -
        evaluation.effort * weights.effort;
    return Math.round(raw);
}
/**
 * Kleinster/groesster erreichbarer Score bei gegebenen Gewichten.
 *
 * Wird für die Balkendarstellung in `ScorePill` gebraucht: ein Score von 12 sagt
 * für sich genommen nichts — erst im Verhaeltnis zur Spannweite wird er lesbar.
 * Negative Gewichte sind nicht vorgesehen, werden hier aber korrekt behandelt.
 */
export function scoreRange(weights = DEFAULT_WEIGHTS) {
    const positive = weights.customerValue + weights.strategicValue + weights.urgency + weights.technicalValue;
    const min = Math.round(positive * CRITERION_MIN - weights.effort * CRITERION_MAX);
    const max = Math.round(positive * CRITERION_MAX - weights.effort * CRITERION_MIN);
    return { min: Math.min(min, max), max: Math.max(min, max) };
}
/**
 * Score als Anteil der Spannweite (0–1) — für Fortschrittsbalken.
 * Bei entarteten Gewichten (Spannweite 0) liefert die Funktion 0 statt NaN.
 */
export function scoreFraction(score, weights = DEFAULT_WEIGHTS) {
    const { min, max } = scoreRange(weights);
    const span = max - min;
    if (span <= 0)
        return 0;
    return Math.min(1, Math.max(0, (score - min) / span));
}
//# sourceMappingURL=scoring.js.map